import React from 'react';

interface LogoProps {
  variant?: 'full' | 'mark' | 'wordmark';
  inverted?: boolean;
  className?: string;
}

/**
 * IdeaVerdict brand mark — emerald pill with scales icon.
 * Mirrors the template's CardFlow lockup pattern.
 */
const Logo: React.FC<LogoProps> = ({ variant = 'full', inverted, className = '' }) => {
  // When `inverted` is explicitly passed, force that color. Otherwise let
  // Tailwind's dark: variant pick the right color from the active theme
  // (html.dark toggled by ThemeContext). Without this, the wordmark was
  // hardcoded dark-slate and disappeared on dark backgrounds.
  const wordColorClass =
    inverted === true ? 'text-white'
    : inverted === false ? 'text-slate-900'
    : 'text-slate-900 dark:text-white';

  const Mark = (
    <span
      className="inline-flex items-center justify-center w-8 h-8 bg-emerald-500 rounded-lg flex-shrink-0"
      style={{ boxShadow: '0 0 12px rgba(16,185,129,0.4)' }}
      aria-hidden="true"
    >
      <i className="ri-scales-3-line text-white text-lg" />
    </span>
  );

  const Wordmark = (
    <span className={`font-display font-bold text-xl tracking-tight whitespace-nowrap leading-none ${wordColorClass}`}>
      IdeaVerdict<span className="text-emerald-500 font-bold">.ai</span>
    </span>
  );

  if (variant === 'mark') {
    return <span className={`inline-flex items-center ${className}`}>{Mark}</span>;
  }

  if (variant === 'wordmark') {
    return <span className={`inline-flex items-center ${className}`}>{Wordmark}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {Mark}
      {Wordmark}
    </span>
  );
};

export default Logo;
